import React from "react";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Chip from "@material-ui/core/Chip";

export const Chips = ({ data, onChange, selectedValue, title, readonly }) => (
  <FormControl style={{ width: "100%" }} disabled={readonly} variant="outlined">
    <InputLabel id="chips-label">{title}</InputLabel>
    <Select
      multiple
      variant="outlined"
      value={selectedValue}
      onChange={event => onChange(event.target.value)}
      id="chips"
      label={title}
      renderValue={selected => (
        <div style={{ whiteSpace: "normal" }}>
          {selected.map(value => {
            const selectedData = data.find(s => s.value === value);
            if (selectedData)
              return (
                <Chip
                  key={value}
                  label={selectedData.label}
                  style={{ margin: "2px 2px 0 0" }}
                  color="primary"
                />
              );
            else return <div key={value} />;
          })}
        </div>
      )}
      MenuProps={MenuProps}
    >
      {data.map(({ value, label }) => (
        <MenuItem key={value} value={value}>
          {label}
        </MenuItem>
      ))}
    </Select>
  </FormControl >
);

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250
    }
  }
};
